import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

export default function CategoryBreakdown({ categories }) {
  const data = categories.map(c => ({
    name: c.category,
    actual: c.actual,
    forecast: c.forecast,
    gap: c.actual - c.forecast,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const d = payload[0]?.payload;
    const accuracy = d.forecast > 0 ? ((1 - Math.abs(d.gap) / d.forecast) * 100).toFixed(1) : 0;
    return (
      <div className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-xs shadow-xl">
        <p className="text-slate-300 font-medium mb-1">{d.name}</p>
        <p className="text-cyan-400">Actual: {d.actual.toLocaleString()}</p>
        <p className="text-emerald-400">Forecast: {d.forecast.toLocaleString()}</p>
        <p className={d.gap >= 0 ? "text-emerald-300" : "text-red-300"}>Gap: {d.gap > 0 ? "+" : ""}{d.gap.toLocaleString()}</p>
        <p className="text-slate-400">Accuracy: {accuracy}%</p>
      </div>
    );
  };

  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6" data-testid="category-breakdown">
      <h3 className="text-base font-semibold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Demand by Category</h3>
      <p className="text-xs text-slate-500 mb-4">Actual vs Forecast (units)</p>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
          <XAxis dataKey="name" tick={{ fill: '#94a3b8', fontSize: 9 }} axisLine={{ stroke: '#1e293b' }} />
          <YAxis tick={{ fill: '#64748b', fontSize: 9 }} tickFormatter={v => v >= 1000 ? `${(v/1000).toFixed(0)}K` : v} axisLine={{ stroke: '#1e293b' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 10, color: '#94a3b8' }} />
          <Bar dataKey="actual" name="Actual" fill="#22d3ee" radius={[4, 4, 0, 0]} barSize={20} />
          <Bar dataKey="forecast" name="Forecast" fill="#334155" radius={[4, 4, 0, 0]} barSize={20} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
